import React from "react";
import { useQuery } from "react-query";

import { useCommonHooks } from "..";

export function useFunctionRef(selectedFunctionIds?: number[]) {
  const { apis } = useCommonHooks();
  const { data, isFetching, refetch } = useQuery(
    ["ref-functions", selectedFunctionIds],
    async () => {
      return apis.referential.functions(selectedFunctionIds);
    },
    { staleTime: Infinity }
  );

  return {
    functions: data,
    functionsLoading: isFetching,
    refetchFunctions: refetch,
  };
}
